import Index from './index.vue'

export default {
  name: 'jobApplicantList',
  path: '/v-admin/job/:jobId/application',
  component: Index,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.application.applicantList.title.list'
  }
}
